// extracted by mini-css-extract-plugin
export default {"table":"OrderHistory_table__7P0rc","icons":"OrderHistory_icons__t6G7u","pending":"OrderHistory_pending__ZlTSI","delivered":"OrderHistory_delivered__kxTPX"};